/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import PropTypes from 'prop-types';

const DropdownInsideLabel = (props) => {
  const { classNames } = props;
  classNames.push('dropdownInsideLabel');

  const onEvent = (e) => {
    if (e.target.value === '') {
      e.target.removeAttribute('notempty');
      /* firefox and IE hack because general sibling selector " ~ label" does not work */
      e.target.nextSibling.removeAttribute('notempty');
    } else {
      e.target.setAttribute('notempty', '');
      /* firefox and IE hack because general sibling selector " ~ label" does not work */
      e.target.nextSibling.setAttribute('notempty', '');
    }
    props.onChange(e);
  };

  return (
    <div className={classNames.join(' ')}>
      <select
        id={props.name}
        name={props.name}
        onChange={onEvent}
        onFocus={onEvent}
        onBlur={onEvent}
        value={props.value}
        autoFocus // eslint-disable-line
      >
        {props.options.map(option => (
          <option
            autoFocus // eslint-disable-line
            key={option.name}
            name={option.name}
            value={option.value}
          >
            {option.display || option.value}
          </option>
        ))}
      </select>
      <div className="arrow-down" />
      <label htmlFor={props.name}>{props.label}</label>
    </div>
  );
};

DropdownInsideLabel.propTypes = {
  options: PropTypes.instanceOf(Array).isRequired,
  classNames: PropTypes.instanceOf(Array),
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func,
};

DropdownInsideLabel.defaultProps = {
  value: '',
  classNames: [],
  onChange: () => {},
};

export default DropdownInsideLabel;
